import { LineAttributes } from "./instance.shader";
// An Instanced version of Line
export class InstancedLine {
    constructor(batch, instanceIndex) {
        this.batch = batch;
        this.instanceIndex = instanceIndex;
    }
    isValid() {
        return this.batch && this.instanceIndex !== -1;
    }
    get visible() {
        if (this.isValid()) {
            return this.isVisible();
        }
        return false;
    }
    set visible(value) {
        if (this.isValid()) {
            this.setVisible(value);
        }
    }
    isVisible() {
        return this.batch.isVisibleAt(this.instanceIndex);
    }
    setVisible(value) {
        this.batch.setVisibleAt(this.instanceIndex, value);
    }
    setStartPoint(point) {
        this.batch.setVector3AttributeAt(LineAttributes.start_point, this.instanceIndex, point);
    }
    setEndPoint(point) {
        this.batch.setVector3AttributeAt(LineAttributes.end_point, this.instanceIndex, point);
    }
    setColor(color) {
        this.batch.setColorAttributeAt(LineAttributes.color, this.instanceIndex, color);
    }
    getColor(color) {
        this.batch.getColorAttributeAt(LineAttributes.color, this.instanceIndex, color);
    }
    setThickness(value) {
        this.batch.setXOfAttributeAt(LineAttributes.line_params, this.instanceIndex, value);
    }
    setFuzzyness(value) {
        this.batch.setYOfAttributeAt(LineAttributes.line_params, this.instanceIndex, value);
    }
    setNoiseFrequency(value) {
        this.batch.setZOfAttributeAt(LineAttributes.line_params, this.instanceIndex, value);
    }
    setNoiseVelocity(value) {
        this.batch.setWOfAttributeAt(LineAttributes.line_params, this.instanceIndex, value);
    }
    destroy() {
        this.batch.deleteInstance(this);
    }
}
